var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "h5",
        { staticClass: "grey-color mt-3 mb-1 main_text font-weight-bold" },
        [_vm._v("Договор")]
      ),
      _c("b-table", {
        staticClass: "table-atmo",
        attrs: {
          busy: _vm.isDataSending,
          fields: _vm.fields,
          items: _vm.contract.contract_files,
          small: "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(created_at)",
            fn: function (data) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$formatDateTime(data.item.created_at)) + " "
                ),
              ]
            },
          },
          {
            key: "cell(contract_attachment)",
            fn: function (data) {
              return [
                data.item.is_archived ? [_vm._v("(Архив) ")] : _vm._e(),
                _c(
                  "a",
                  {
                    staticClass: "atmo-button-link",
                    staticStyle: { color: "var(--green-color) !important" },
                    attrs: {
                      href: _vm.$getAttachmentDownloadLink(
                        data.item.contract_attachment.id
                      ),
                      target: "_blank",
                    },
                  },
                  [_vm._v(_vm._s(data.item.contract_attachment.name))]
                ),
                !data.item.is_archived && _vm.contract.status.subtitle
                  ? _c("div", [
                      _vm._v(" " + _vm._s(_vm.contract.status.subtitle) + " "),
                    ])
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(contract_with_signature)",
            fn: function (data) {
              return [
                !data.item.is_archived && _vm.contract.zip_name
                  ? _c("action-button-small", {
                      staticClass: "ml-1",
                      attrs: {
                        icon: "file-earmark-zip",
                        title: "Скачать одним файлом",
                        variant: "outline",
                      },
                      on: { click: _vm.downloadZip },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(contract_print_form)",
            fn: function (data) {
              return [
                !data.item.is_archived
                  ? [
                      _vm.contract.pdf_name
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "file-pdf",
                              title:
                                "Скачать печатную форму с оттисками подписей",
                              variant: "outline",
                            },
                            on: { click: _vm.downloadPdf },
                          })
                        : _c("action-button-small", {
                            staticClass: "ml-1 border-danger text-danger",
                            attrs: {
                              icon: "exclamation-lg",
                              title:
                                "Важно! На основе загруженного документа печатная форма не может быть сформирована",
                              variant: "outline",
                              scale: 1,
                            },
                          }),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(sign_customer)",
            fn: function (data) {
              return [
                data.item.customer_signature
                  ? [
                      _c("action-button-small", {
                        attrs: {
                          icon: "clipboard-check",
                          title: "Информация о подписи",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSign(
                              true,
                              data.item.customer_signature
                            )
                          },
                        },
                      }),
                      data.item.customer_signature.poa_number &&
                      data.item.customer_signature.poa_check_link
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "clipboard-plus",
                              title: "Информация о МЧД",
                              variant: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(
                                  true,
                                  data.item.customer_signature
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _c("action-button-small", {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "cloud-download",
                          title: "Скачать файл подписи",
                          variant: "outline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.download(
                              data.item.customer_signature.md5,
                              true,
                              data.item.contract_attachment.name
                            )
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(sign_supplier)",
            fn: function (data) {
              return [
                data.item.supplier_signature
                  ? [
                      _c("action-button-small", {
                        attrs: {
                          icon: "clipboard-check",
                          title: "Информация о подписи",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSign(
                              false,
                              data.item.supplier_signature
                            )
                          },
                        },
                      }),
                      data.item.supplier_signature.poa_number &&
                      data.item.supplier_signature.poa_check_link
                        ? _c("action-button-small", {
                            staticClass: "ml-1",
                            attrs: {
                              icon: "clipboard-plus",
                              title: "Информация о МЧД",
                              variant: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showSign(
                                  false,
                                  data.item.supplier_signature
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _c("action-button-small", {
                        staticClass: "ml-1",
                        attrs: {
                          icon: "cloud-download",
                          title: "Скачать файл подписи",
                          variant: "outline",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.download(
                              data.item.supplier_signature.md5,
                              false,
                              data.item.contract_attachment.name
                            )
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm.signData.signature
        ? _c("show-sign-modal", {
            attrs: {
              signature: _vm.signData.signature,
              "org-is-customer": _vm.signData.isCustomer,
              show: _vm.showSignModal,
            },
            on: {
              close: function ($event) {
                _vm.showSignModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }